import { Actions, Button, Inline } from 'braid-design-system';

export const Submit = () => (
  <Inline space="small" alignY="center">
    <Actions>
      <Button tone="brandAccent" type="submit" id="security-breach-submit">
        Submit
      </Button>
    </Actions>
  </Inline>
);
